/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { changes_ChangesFeedResponse } from '../models/changes_ChangesFeedResponse';
import type { changes_ChangesFeedSummaryResponse } from '../models/changes_ChangesFeedSummaryResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChangesFeedService {
    /**
     * Get changes feed
     * Returns a paginated feed of upcoming arrivals, departures, schedule changes, and group transfers
     * @param groupId Filter by group ID
     * @param fromDate Start date (YYYY-MM-DD)
     * @param toDate End date (YYYY-MM-DD)
     * @param changeType Filter by change type
     * @param lookaheadDays Lookahead days (default 30, max 365)
     * @param limit Limit (default 20, max 100)
     * @param offset Offset (default 0)
     * @returns changes_ChangesFeedResponse OK
     * @throws ApiError
     */
    public static getApiV1ChangesFeed(
        groupId?: string,
        fromDate?: string,
        toDate?: string,
        changeType?: 'all' | 'arrival' | 'departure' | 'schedule_change' | 'group_transfer',
        lookaheadDays?: number,
        limit?: number,
        offset?: number,
    ): CancelablePromise<changes_ChangesFeedResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/changes-feed',
            query: {
                'group_id': groupId,
                'from_date': fromDate,
                'to_date': toDate,
                'change_type': changeType,
                'lookahead_days': lookaheadDays,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get changes feed summary
     * Returns per-group counts of upcoming arrivals and departures for dashboard display
     * @param groupId Filter by group ID
     * @param lookaheadDays Lookahead days (default 30, max 365)
     * @param referenceDate Reference date (YYYY-MM-DD, default: today)
     * @returns changes_ChangesFeedSummaryResponse OK
     * @throws ApiError
     */
    public static getApiV1ChangesFeedSummary(
        groupId?: string,
        lookaheadDays?: number,
        referenceDate?: string,
    ): CancelablePromise<changes_ChangesFeedSummaryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/changes-feed/summary',
            query: {
                'group_id': groupId,
                'lookahead_days': lookaheadDays,
                'reference_date': referenceDate,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        });
    }
}
